exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-hidden=\"true\"] {\n  display: none !important; }\n\ninput.day, input.time {\n  min-width: 110px; }\n\ninput.daytime, input.month {\n  min-width: 160px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/nbinput/nbinput-date.component.scss
// module id = 173
// module chunks = 0 1